module.exports = __webpack_public_path__ + "static/media/logo__0012_Homeland.56b1c487.png";